const APPLE_SHORTCUT_PLATFORM_PATTERN = /Mac|iPhone|iPad|iPod/i;

export function resolveHistoryShortcutModifier(): "Ctrl" | "⌘" {
  if (typeof navigator === "undefined") return "Ctrl";
  return APPLE_SHORTCUT_PLATFORM_PATTERN.test(`${navigator.platform} ${navigator.userAgent}`)
    ? "⌘"
    : "Ctrl";
}
